import request from '@/utils/request'


export function getPageList(data) {
  return request({
    url: 'Award/getPageList',
    method: 'post',
    data,
  })
}

export function getAll(data) {
  return request({
    url: 'Award/getAll',
    method: 'post',
    data,
  })
}

export function save(data) {
  return request({
    url: 'Award/save',
    method: 'post',
    data,
  })
}

export function Delete(data) {
  return request({
    url: 'Award/Delete',
    method: 'post',
    data,
  })
}